// 429 rate-limit 을 감지한 transport 가 "오버레이를 띄워라"를 알리는 zero-dep 통로.
//
// **왜 store 를 직접 부르지 않는가** — `errorInterceptor` 가
// `app/_hook/.../useRateLimitOverlayStore` 를 import 하면 그 store 가 `viewup-lib/common` 의
// `createSelector` 와 zustand 를 **errorInterceptor 를 import 하는 모든 모듈의 그래프로** 끌고
// 온다. 실제로 그렇게 넣어 봤다가 `BankAdd.test.tsx` 가 `createSelector is not a function` 으로
// suite 째로 죽었다 — 그 테스트의 mock 세팅이 store 를 상정하지 않기 때문이다. 즉 이건 스타일
// 문제가 아니라 `shared/` 가 app 레이어를 import 하면 안 된다는 `shared/CLAUDE.md` 불변식이
// 실제로 물어뜯은 사례다.
//
// 그래서 shared 는 "429 가 났고 이 시각까지 기다려야 한다"만 알리고, 그걸 오버레이 store 에
// 꽂는 일은 app 레이어(`QueryProvider`)가 맡는다. 의존 방향이 `app → shared` 한쪽으로만 남는다.

export type RateLimitListener = (resetAt: number) => void;

let listener: RateLimitListener | undefined;

/**
 * 리스너를 등록한다. app 레이어에서만 호출한다 (`QueryProvider`).
 *
 * 하나만 유지한다 — 여러 곳에서 등록할 이유가 없고, 배열로 두면 테스트나 HMR 에서 중복
 * 등록이 쌓여 같은 429 로 trigger 가 N 번 불린다. 해제는 `undefined` 를 넘긴다.
 */
export function setRateLimitListener(next: RateLimitListener | undefined): void {
  listener = next;
}

/**
 * 429 를 알린다. 리스너가 없으면 **조용히 아무 일도 하지 않는다** — SSR 이나 리스너 등록 전에
 * 온 429 를 에러로 만들 이유가 없다(오버레이는 UI 이고, 서버엔 띄울 화면이 없다).
 */
export function notifyRateLimit(resetAt: number): void {
  listener?.(resetAt);
}
